import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyFile, HttpResponse } from "@/types";

export function useDeleteCompanyFile() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({ companyFileId }: { companyFileId: number }) => {
      const path = `companies/${currentCompanyId}/files/${companyFileId.toString()}`;
      const res = await guacHttpClient.delete<
        CompanyFile,
        HttpResponse<CompanyFile>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
